/**
 * 表单字段列表编辑器。字段结构与 @h5/materials form/schema.ts 的 FormFieldSchema 对齐：
 * { id, type: 'input'|'textarea'|'select'|'radio'|'checkbox'|'phone', label, placeholder, required, options: string[] }
 */
import { Button, Input, Select, Space, Switch } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { genId } from '@h5/schema';

export interface FormField {
  id: string;
  type: 'input' | 'textarea' | 'select' | 'radio' | 'checkbox' | 'phone';
  label: string;
  placeholder: string;
  required: boolean;
  options: string[];
}

const TYPES: { label: string; value: FormField['type'] }[] = [
  { label: '单行文本', value: 'input' }, { label: '多行文本', value: 'textarea' }, { label: '手机号', value: 'phone' },
  { label: '下拉', value: 'select' }, { label: '单选', value: 'radio' }, { label: '多选', value: 'checkbox' },
];

interface Props { value: unknown; onChange(v: FormField[]): void }

export function FormFieldsSetter({ value, onChange }: Props) {
  const fields: FormField[] = Array.isArray(value) ? (value as FormField[]) : [];
  const update = (i: number, patch: Partial<FormField>) => onChange(fields.map((f, j) => (j === i ? { ...f, ...patch } : f)));
  const remove = (i: number) => onChange(fields.filter((_, j) => j !== i));
  const add = () => onChange([...fields, { id: genId('f'), type: 'input', label: `字段 ${fields.length + 1}`, placeholder: '', required: false, options: [] }]);
  return (
    <Space direction="vertical" style={{ width: '100%' }} size={8}>
      {fields.map((f, i) => (
        <div key={f.id} style={{ border: '1px solid #f0f0f0', borderRadius: 6, padding: 8 }}>
          <Space direction="vertical" style={{ width: '100%' }} size={6}>
            <Space.Compact style={{ width: '100%' }}>
              <Input size="small" value={f.label} placeholder="标签" onChange={(e) => update(i, { label: e.target.value })} />
              <Button size="small" danger icon={<DeleteOutlined />} onClick={() => remove(i)} />
            </Space.Compact>
            <Input size="small" value={f.placeholder} placeholder="占位提示" onChange={(e) => update(i, { placeholder: e.target.value })} />
            <Space style={{ width: '100%', justifyContent: 'space-between' }}>
              <Select size="small" style={{ width: 120 }} value={f.type} options={TYPES} onChange={(v) => update(i, { type: v })} />
              <span style={{ fontSize: 12 }}>必填 <Switch size="small" checked={f.required} onChange={(v) => update(i, { required: v })} /></span>
            </Space>
            {['select', 'radio', 'checkbox'].includes(f.type) && (
              <Select mode="tags" size="small" style={{ width: '100%' }} placeholder="输入选项后回车" value={f.options ?? []} onChange={(v) => update(i, { options: v })} />
            )}
          </Space>
        </div>
      ))}
      <Button block size="small" icon={<PlusOutlined />} onClick={add}>添加字段</Button>
    </Space>
  );
}
